import { ReferenceFieldsForm } from "@/src/app/fields/referenceFieldsForm";
import {
  DocumentTemplate,
  Patient,
  PatientDocument,
  StructureUnitType,
} from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import {
  getItemId,
  getUserId,
  getUserShortName,
  jsonAbstract,
  openToast,
  uid,
} from "@/src/utils/utils";
import {
  closeDialog,
  closeDrawer,
  openConfirmDialog,
  openDialog,
  openDrawer,
} from "../../components/dialogs";
import { DocumentEditor, PrintablePatientHeader } from "./documentEditor";
import { RegistryNumberPicker } from "./registryNumberPicker";

async function openDocumentForm({
  patient,
  patientDocument,
  onChange,
  onSave,
  onValidate,
}: {
  patient: Patient | null | undefined;
  patientDocument: PatientDocument;
  onChange?: (newValue: PatientDocument) => void;
  onSave?: (newValue: PatientDocument) => void;
  onValidate?: (newValue: PatientDocument) => void;
}) {
  let template = patientDocument?.template;
  let formulaire = template?.reference || patientDocument?.refAnswer?.reference;
  if (!formulaire) {
    // let audioSession: AiAudioSession = {};
    // await openDocumentAiAssistant({
    //   patient: patient!,
    //   audioSession: audioSession,
    //   item: null,

    // });
    return await openEditor({ patient, patientDocument, onSave, onValidate });
  }

  patientDocument.refAnswer ||= {
    reference: formulaire,
    creator: USER?.get(),
    fieldAnswers: [],
    patient: patientDocument.patient,
    notes: "",
    conclusion: "",
  };

  await openDrawer({
    id: "referenceDialog",
    title: "Formulaire",
    additionalClasses: ["medium"],
    confirmBeforeClose: true,
    content: (
      <div className="c1 gap10">
        {template?.registryName != null && (
          <RegistryNumberPicker
            key={uid()}
            value={patientDocument.registryNumber || 0}
            template={template}
            onChange={(newValue) => {
              patientDocument.registryNumber = newValue;
            }}
          />
        )}

        <ReferenceFieldsForm
          patient={patient}
          currentAnswers={patientDocument.refAnswer?.fieldAnswers || []}
          item={patientDocument.parent}
          reference={formulaire}
          onChange={(newFieldAnswers) => {
            patientDocument.refAnswer!.fieldAnswers = newFieldAnswers;
          }}
        />
      </div>
    ),

    onConfirm: async () => {
      if (
        getItemId(patientDocument?.creator) &&
        getItemId(patientDocument?.creator) != getItemId(USER?.get())
      ) {
        patientDocument = await openDifferentUserConfirmation({
          patientDocument,
        });
        if (patientDocument.id) return;
      }

      try {
        patientDocument!.template = jsonAbstract(patientDocument?.template?.id);
        let result = await apiFetch(
          "patientDocuments",
          "addOne",
          {
            registryName: template?.registryName,
            patientDocument,
          },
          "Erreur lors de l'enregistrement du document"
        );
        patientDocument = result;
        closeDrawer("documentTemplateChoiceDrawer");
        closeDrawer("referenceDialog");
        openToast("success", "Document enregistré avec succès");

        await openEditor({
          patient,
          patientDocument,
          onSave: async (newValue) => {
            onSave?.(newValue);
          },
          onValidate: async (newValue) => {
            onValidate?.(newValue);
          },
        });

        onChange?.(patientDocument);
      } catch (e: any) {
        console.log("the message", {
          message: e.message,
          patientDocument,
          docuLength: JSON.stringify(patientDocument).length,
        });
        if (e.message == "not_available_number") {
          await openConfirmDialog({
            id: "not_available_number",
            title: "Erreur",
            content: `Le numéro de registre est déjà utilisé, veuillez réessayer`,
            onConfirm: async () => {
              closeDialog("not_available_number");
            },
          });
        }
        return false;
      }

      return false;
    },
  });
  return patientDocument;
}

async function openTemplateEditor({
  template,
  onSave,
}: {
  template: DocumentTemplate;
  onSave?: (newValue: DocumentTemplate) => void;
}) {
  await openDialog({
    id: "documentEditorDialog",
    confirmBeforeClose: true,
    title: null,
    content: (
      <DocumentEditor
        isTemplate={true}
        getSubHeader={(patientDocument) => {
          if (template.showPatientIdentity)
            return (
              <PrintablePatientHeader
                patient={null}
                folderItem={null}
                patientDocument={patientDocument}
              ></PrintablePatientHeader>
            );
        }}
        sections={template?.reference?.sections || []}
        patientDocument={null}
        currentTitle={template.title || "Nouveau document"}
        currentContent={template.content}
        allowedButtons={[
          "format",
          "size",
          "bold",
          "underline",
          "align",
          "undo",
          "redo",
          "variable",
          "html",
          "save",
        ]}
        onTitleChange={(newTitle) => {
          template.title = newTitle;
        }}
        onChange={async (newValue) => {
          template.content = newValue;
        }}
        onSave={async () => {
          onSave?.(template);
        }}
      />
    ),
    footer: <div></div>,
  });
}

async function openEditor({
  patient,
  patientDocument,
  showHorizontalScroll,
  onChange,
  onSave,
  onValidate,
  onPrint,
}: {
  patient: Patient | null | undefined;
  patientDocument: PatientDocument;
  showHorizontalScroll?: boolean;
  onChange?: (newValue: PatientDocument) => void;
  onSave?: (newValue: PatientDocument) => void;
  onValidate?: (newValue: PatientDocument) => void;
  onPrint?: () => void;
}): Promise<PatientDocument> {
  if (patient) patientDocument.patient = patient;
  let template = patientDocument?.template;
  console.log("theee parent", patientDocument?.parent);
  await openDialog({
    id: "documentEditorDialog",
    confirmBeforeClose: true,
    title: null,
    content: (
      <DocumentEditor
        isTemplate={false}
        showHorizontalScroll={showHorizontalScroll}
        patientDocument={patientDocument}
        currentContent={patientDocument.content}
        currentTitle={patientDocument.title || "Nouveau document"}
        sections={patientDocument?.refAnswer?.reference?.sections}
        showHeader={template?.showHeader}
        showLeftBar={template?.showLeftBar}
        barcodeLocation={template?.barcodeLocation}
        showTitle={template?.showTitle}
        getSubHeader={(patientDocument) => {
          if (template?.showPatientIdentity)
            return (
              <PrintablePatientHeader
                patient={patient}
                patientDocument={patientDocument}
                folderItem={patientDocument?.parent}
              ></PrintablePatientHeader>
            );
        }}
        allowedButtons={[
          "format",
          "size",
          "bold",
          "underline",
          "align",
          "undo",
          "redo",
          "validate",
          "print",
          "ai",
          "save",
        ]}
        onTitleChange={(newTitle) => {
          patientDocument.title = newTitle;
        }}
        onChange={async (newValue) => {
          patientDocument.content = newValue;
          onChange?.(patientDocument);
        }}
        onSave={async () => {
          if (patientDocument?.creator?.id != USER?.get()?.id) {
            patientDocument = await openDifferentUserConfirmation({
              patientDocument,
            });
            if (patientDocument.id) return;
          }

          let result = await apiFetch(
            "patientDocuments",
            "addOne",
            {
              patientDocument,
            },
            "Erreur lors de l'enregistrement du document"
          );
          patientDocument = result;
          onChange?.(patientDocument);
          onSave?.(patientDocument);
          closeDialog("documentEditorDialog");
          closeDrawer("documentTemplateChoiceDrawer");
        }}
        onValidate={async () => {
          let result = await apiFetch(
            "patientDocuments",
            "addOne",
            {
              patientDocument: {
                id: patientDocument.id,
                content: patientDocument.content,
                isValidatedBy: getUserId(),
                title: patientDocument.title,
                status: "validated",
              } as PatientDocument,
            },
            "Erreur lors de la validation du document"
          );
          patientDocument = result;
          onChange?.(patientDocument);
          onValidate?.(patientDocument);
        }}
        onPrint={onPrint}
      />
    ),
    footer: <div></div>,
  });
  return patientDocument;
}

async function openDifferentUserConfirmation({
  patientDocument,
}: {
  patientDocument: PatientDocument;
}): Promise<PatientDocument> {
  await openConfirmDialog({
    title: "Modifier le document",
    content: `Ce document a initialiement été rempli par ${getUserShortName(
      patientDocument?.creator
    )}, voulez-vous vraiment créer une copie modifiée ?`,
    onConfirm: async () => {
      patientDocument.id = null;
      patientDocument.initialCreator = getItemId(patientDocument.creator);
      patientDocument.creator = USER?.get();
    },
  });
  return patientDocument;
}

function getAllServiceDocumentTemplates({
  unitType,
}: {
  unitType: StructureUnitType;
}) {
  let units = USER?.get()?.service?.units;

  if (unitType) units = units?.filter((unit) => unit?.type == unitType);

  return units?.map((unit) => unit?.documentTemplates).flat();
}

export {
  getAllServiceDocumentTemplates,
  openDocumentForm,
  openEditor,
  openTemplateEditor,
};
